import { cubicEaseOut } from '@helpers/animation';
import brand, { colourWithTransparency } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import svgArrow from '@img/icons/select-arrow.svg';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const TopBar = styled.div `
  @media ${until(Device.TabletLarge)} {
    display: grid;
    gap: 24px;
    flex-direction: column;
    margin: 0 0 40px;
  }

  @media ${from(Device.TabletLarge)} {
    display: grid;
    gap: 24px 40px;
    margin: 0 0 40px;

    ${() => PageCount} {
      align-self: flex-end;
      grid-column: 1;
      justify-self: flex-start;
    }

    ${() => PageSize} {
      grid-column: 2;
      justify-self: flex-end;
    }
  }
`;
const FilterList = styled.div `
  @media ${until(Device.TabletLarge)} {
    display: flex;
    flex-direction: column;
  }

  @media ${from(Device.TabletLarge)} {
    display: flex;
    flex-direction: row;
  }
`;
const FilterItem = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${until(Device.TabletLarge)} {
    & + & {
      margin-top: 16px;
    }
  }

  @media ${from(Device.TabletLarge)} {
    & + & {
      margin-left: 16px;
    }
  }
`;
const FilterLabel = styled.label `
  display: block;
  ${fonts.sofiaPro.semiBold};
  font-size: 16px;
  letter-spacing: 0.01em;
  line-height: 28px;
  margin: 0 0 8px;

  @media ${from(Device.MobileLarge)} {
    font-size: 18px;
    line-height: 32px;
  }
`;
const FilterSelect = styled.select `
  display: inline-block;
  appearance: none;
  background-image: url(${svgArrow});
  background-repeat: no-repeat;
  background-position: right 30px center;
  border: ${brand.grey.grey90} 1px solid;
  border-radius: 30px;
  box-sizing: border-box !important;
  ${fonts.sofiaPro.regular};
  font-size: 18px;
  height: 50px;
  letter-spacing: -0.02em;
  line-height: 1.5em;
  margin: 0;
  opacity: 1;
  padding: 0 94px 0 32px;
  text-transform: none;
  transition: opacity 0.3s ease-out;
  width: auto;

  &:focus {
    border-color: ${brand.primary.blue.base};
  }

  &:disabled {
    opacity: 0.4;
  }

  @media ${until(Device.TabletLarge)} {
    width: 100%;
  }
`;
const PageCount = styled.div `
  display: block;
  ${fonts.sofiaPro.semiBold};
  font-size: 16px;
  letter-spacing: 0.01em;
  line-height: 28px;
  margin: 0;

  @media ${until(Device.TabletLarge)} {
    text-align: center;
  }

  @media ${from(Device.MobileLarge)} {
    font-size: 18px;
    line-height: 32px;
  }
`;
const PageSize = styled.div `
  display: flex;
  flex-direction: column;
`;
const ItemList = styled.div `
  display: grid;
  gap: 24px 10px;
  grid-template-columns: repeat(12, 1fr);

  @media ${from(Device.Tablet)} {
    gap: 40px;
  }
`;
const Item = styled.div `
  grid-column: span 12;

  @media ${from(Device.Tablet)} {
    grid-column: span 6;
  }

  @media ${from(Device.Desktop)} {
    grid-column: span 4;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: span 3;
  }
`;
const BottomBar = styled.div `
  display: grid;
  margin: 40px 0 0;
`;
const Filters = styled.form `
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 7;
  top: -10px;
  margin-bottom: 10px;

  @media ${from(Device.TabletLarge)} {
    top: -50px;
    margin-bottom: 0px;
  }
`;
const FiltersContainer = styled.div `
  display: grid;
  background: ${brand.white};
  border-radius: 4px;
  grid-template-columns: repeat(2, 1fr);
  box-shadow: 0 0 4px ${colourWithTransparency(brand.black, 0.25)};

  @media ${until(Device.Tablet)} {
    grid-template-columns: 1fr;
  }
`;
const Select = styled.select `
  appearance: none;
  background-image: url(${svgArrow});
  background-repeat: no-repeat;
  background-position: right 0 center;
  background-color: ${brand.white};
  border: 0;
  color: #919191;
  ${fonts.sofiaPro.bold};
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  padding: 0 20px 0 0;
  width: 100%;

  option:disabled {
    background-color: rgba(0, 0, 0, 0.1);
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
  }

  &[data-has-value='true'] {
    color: ${brand.primary.blue.base};
  }
`;
const SearchButton = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${brand.primary.blue.base};
  border: 2px solid ${brand.primary.blue.base};
  border-radius: 25px;
  color: ${brand.white};
  ${fonts.sofiaPro.semiBold};
  font-size: 14px;
  width: 100%;
  height: 50px;
  line-height: 20px;
  padding: 0 15px;
  text-transform: uppercase;
  transition: color 0.3s ${cubicEaseOut}, background-color 0.3s ${cubicEaseOut},
    border-color 0.3s ${cubicEaseOut};
  user-select: none;
  white-space: nowrap;

  &:hover {
    border-color: ${brand.primary.blue.light};
    background-color: ${brand.primary.blue.light};
    color: ${brand.white};
  }

  &:active {
    border-color: ${brand.primary.blue.base};
    background-color: ${brand.primary.blue.base};
    color: ${brand.white};
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 22px;
    padding: 0 32px;
  }

  svg {
    margin-right: 12px;
    height: 23px;
  }
`;
const OfferListingStyles = {
    BottomBar,
    Container,
    FilterItem,
    FilterLabel,
    FilterList,
    FilterSelect,
    Filters,
    Item,
    ItemList,
    PageCount,
    PageSize,
    TopBar,
    Select,
    FiltersContainer,
    SearchButton,
};
export default OfferListingStyles;
